import { BYO_OPEN_MODAL, BYO_CLOSE_MODAL, BYO_OPENING_FROM_CAMPAIGN, } from '../constants';
export const openModal = () => ({
    type: BYO_OPEN_MODAL,
});
export const closeModal = () => ({
    type: BYO_CLOSE_MODAL,
});
export const setIsOpeningFromCampaign = (flag) => ({
    type: BYO_OPENING_FROM_CAMPAIGN,
    payload: flag,
});
